var _path, _rect, _rect2, _rect3, _rect4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBarGraphStocks(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 67,
    viewBox: "0 0 136 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52 4.5L52.6649 4.15308L52.531 3.89635L52.2593 3.79624L52 4.5ZM58 16L57.3351 16.3469L57.4214 16.5123L57.5751 16.618L58 16ZM74 27L74.5431 26.4828L74.4892 26.4262L74.4249 26.382L74 27ZM84 37.5L83.4569 38.0172L83.5723 38.1384L83.7282 38.199L84 37.5ZM93 41L87.5794 34.246L84.4405 42.3174L93 41ZM42.2407 1.70376L51.7407 5.20376L52.2593 3.79624L42.7593 0.296243L42.2407 1.70376ZM51.3351 4.84692L57.3351 16.3469L58.6649 15.6531L52.6649 4.15308L51.3351 4.84692ZM57.5751 16.618L73.5751 27.618L74.4249 26.382L58.4249 15.382L57.5751 16.618ZM73.4569 27.5172L83.4569 38.0172L84.5431 36.9828L74.5431 26.4828L73.4569 27.5172ZM83.7282 38.199L86.4371 39.2525L86.9808 37.8545L84.2718 36.801L83.7282 38.199Z",
    fill: "#00FFE8"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 13,
    width: 11,
    height: 53,
    rx: 2,
    fill: "#00FFE8",
    fillOpacity: 0.25
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 27,
    width: 11,
    height: 39,
    rx: 2,
    fill: "#00FFE8",
    fillOpacity: 0.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 44,
    width: 10,
    height: 22,
    rx: 2,
    fill: "#00FFE8",
    fillOpacity: 0.75
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 83,
    y: 51,
    width: 11,
    height: 15,
    rx: 2,
    fill: "#00FFE8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarGraphStocks);
export default __webpack_public_path__ + "static/media/bar-graph-stocks.2ef0cb11a206da7cc2256869c9de707d.svg";
export { ForwardRef as ReactComponent };